"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerTypeService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const notification_service_1 = require("./notification.service");
const permission_service_1 = require("./permission.service");
let DemandPartnerTypeService = class DemandPartnerTypeService {
    constructor(_http, _talk, _permission) {
        this._http = _http;
        this._talk = _talk;
        this._permission = _permission;
        //declarations
        this.partnerURL = '/partnerType';
    }
    get() {
        return this.demandPartnerTypes;
    }
    permissionedTypes() {
        let types = JSON.parse(JSON.stringify(this.demandPartnerTypes));
        return types.filter(t => {
            //return this._permission.get()['use-'+t.type+'-side-demand-partners'];
            if (t.type == 'client') {
                return this._permission.get()['use-' + t.type + '-side-demand-partners'];
            }
            else {
                return false;
            }
        });
    }
    pull() {
        return this._http.get(this.partnerURL)
            .toPromise()
            .then(response => this.demandPartnerTypes = JSON.parse(response._body))
            .catch(this._talk.handle);
    }
};
exports.DemandPartnerTypeService = DemandPartnerTypeService;
exports.DemandPartnerTypeService = DemandPartnerTypeService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        permission_service_1.PermissionService])
], DemandPartnerTypeService);
//# sourceMappingURL=demand-partner-type.service.js.map